import { render, staticRenderFns } from "./BadgesContent.vue?vue&type=template&id=23bd04f8&scoped=true&"
import script from "./BadgesContent.vue?vue&type=script&lang=js&"
export * from "./BadgesContent.vue?vue&type=script&lang=js&"
import style0 from "./BadgesContent.vue?vue&type=style&index=0&id=23bd04f8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bd04f8",
  null
  
)

export default component.exports